import { render, staticRenderFns } from "./MySubscriptions.vue?vue&type=template&id=0665834a&scoped=true&"
import script from "./MySubscriptions.vue?vue&type=script&lang=ts&"
export * from "./MySubscriptions.vue?vue&type=script&lang=ts&"
import style0 from "./MySubscriptions.vue?vue&type=style&index=0&id=0665834a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0665834a",
  null
  
)

export default component.exports